import { useState, useEffect } from 'react';
import ProfileService from 'services/ProfileService';
import { useAuthUser } from 'features/auth/AuthUserContext';

export default function usePlan() {
  const [plan, setPlan] = useState(null);
  const { isLoading: isLoadingUser, isAuthenticated } = useAuthUser();
  const [isLoadingPlan, setIsLoadingPlan] = useState(true);

  useEffect(() => {
    async function fetchData() {
      setIsLoadingPlan(true);

      try {
        const service = new ProfileService();
        const { data } = await service.getPlan();

        setPlan(data);
      } catch (e) {
        console.error(e);
      } finally {
        setIsLoadingPlan(false);
      }
    }

    // Only fetch if user is authenticated and not loading
    if (!isLoadingUser && isAuthenticated) {
      fetchData();
    } else if (!isLoadingUser && !isAuthenticated) {
      setIsLoadingPlan(false);
      setPlan(null);
    }
  }, [isLoadingUser, isAuthenticated]);

  return [plan, setPlan, isLoadingPlan];
}
